import { Button } from "@mui/material";
import { Pagination as DynamicPagination, Modal } from "@components/index";
import AddUserForm from "./components/AddUserForm";
import UserListRender from "./components/UserListRender";
import UserFilters from "./components/UserFilters";
import { useUserManagementData } from "./userManagementData";

import "./index.scss";

const UserManagement = () => {
  const {
    openAddNewUserModal,
    setOpenAddNewUserModal,
    openEditUserModal,
    setOpenEditUserModal,
    editingUser,
    handleAddNewUser,
    currentUserList,
    allUserList,
    onEditUser,
    filters,
    handleFilterChange,
    handleClearFilters,
    currentPage,
    handlePageChange,
  } = useUserManagementData();

  return (
    <div className="container">
      <div
        className="header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 className="title" style={{ margin: 0 }}>
          User Management
        </h1>
        <div className="__submit-buttons">
          <Button
            type="submit"
            variant="contained"
            size="large"
            className="add-user-button"
            onClick={handleAddNewUser}
          >
            Add New User
          </Button>

          <Button
            type="submit"
            variant="contained"
            size="large"
            className="download-temp-button"
            // onClick={handleAddNewUser}
          >
            Download Template
          </Button>
        </div>
      </div>

      <div className="user-list-body">
        <UserFilters
          filters={filters}
          onFilterChange={handleFilterChange}
          onClearFilters={handleClearFilters}
        />

        <div className="user-list-separator" />

        <div className="user-list-section">
          <UserListRender userList={currentUserList} onEditUser={onEditUser} />

          {/* Pagination Component */}
          <DynamicPagination
            data={allUserList}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            itemsPerPage={10}
            showInfo={true}
            showFirstButton={true}
            showLastButton={true}
          />
        </div>
      </div>

      {/* Add New User Modal */}
      <Modal
        isOpen={openAddNewUserModal}
        onClose={() => setOpenAddNewUserModal(false)}
        className="my-custom-modal"
        closeOnOutsideClick={false}
      >
        <div>
          <AddUserForm
            onCancel={() => setOpenAddNewUserModal(false)}
            onSubmit={() => setOpenAddNewUserModal(false)}
          />
        </div>
      </Modal>

      {/* Edit User Modal */}
      <Modal
        isOpen={openEditUserModal}
        onClose={() => setOpenEditUserModal(false)}
        className="my-custom-modal"
        closeOnOutsideClick={false}
      >
        <div>
          <AddUserForm
            id={editingUser?.id}
            initialData={editingUser}
            onCancel={() => setOpenEditUserModal(false)}
            onSubmit={() => setOpenEditUserModal(false)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default UserManagement;
